import React, { useEffect, useState,useRef } from 'react';
import axios from 'axios';
import { useAuth } from '../../Context/UserContext/index.tsx';
import certificateTemplate from '../../Assets/cert.png';


export default function Index() {
  const [courseInfo, setCourseInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
const {batchNo,username,canName,SetCourseDate}=useAuth()

 const canvasRef = useRef<HTMLCanvasElement>(null);
  const [userName, setUserName] = useState('');

  // const generateCertificate = () => {
  //   const canvas = canvasRef.current;
  //   if (!canvas) return;
  //   const ctx = canvas.getContext('2d');
  //   if (!ctx) return;

  //   const image = new Image();
  //   image.src = certificateTemplate;

  //   image.onload = () => {
  //     canvas.width = image.width;
  //     canvas.height = image.height;

  //     // Draw certificate background
  //     ctx.drawImage(image, 0, 0);

  //     // Draw user's name
  //     ctx.font = 'bold 40px Arial';
  //     ctx.fillStyle = '#000';
  //     ctx.textAlign = 'center';

  //     // You can adjust the Y position based on where the name should appear
  //   ctx.fillText(userName, canvas.width / 2, 350);


  //     // Download
  //     const link = document.createElement('a');
  //     link.download = `Certificate-${userName}.png`;
  //     link.href = canvas.toDataURL('image/png');
  //     link.click();
  //   };
  // };
  useEffect(() => {
    const fetchCourseInfo = async () => {
      try {
        const response = await axios.get(`https://elearn-api.onrender.com/api/course-info/${batchNo}`);
        setCourseInfo(response.data);
const courseStartDateRaw = response.data[0].CourseStartDate;
const [year, month, day] = courseStartDateRaw.split("T")[0].split("-");
const courseStartDateFormatted = `${day}/${month}/${year}`;
SetCourseDate(courseStartDateFormatted)
console.log("Formatted Course Start Date:", courseStartDateFormatted);
// Output: "14/05/2025"



        
      } catch (err) {
        console.error('Error fetching course info:', err);
        setError('Failed to load course info.');
      } finally {
        setLoading(false);
      }
    };

    fetchCourseInfo();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
    <div>
      <h2 className="course-title">Course Info</h2>
      {courseInfo.map((course, index) => (
        <div key={index} style={{ border: '1px solid #ccc', marginBottom: '1rem', padding: '1rem' }}>
          <p><strong>Candidate Name:</strong> {canName}</p>
          <p><strong>NRIC:</strong> {username}</p>
          <p><strong>Class Name:</strong> {course.ClassName}</p>
          <p><strong>Total Hours:</strong> {course.TotalHours}</p>
          <p><strong>Course ID:</strong> {course.CourseID}</p>
          <p><strong>Course Name:</strong> {course.CourseName}</p>
       <p><strong>Start Date:</strong> {
  course.CourseStartDate &&
  course.CourseStartDate.split("T")[0].split("-").reverse().join("/")
}</p>

<p><strong>End Date:</strong> {
  course.CourseEndDate &&
  course.CourseEndDate.split("T")[0].split("-").reverse().join("/")
}</p>

        </div>
      ))}
    </div>
      {/* <div style={{ textAlign: 'center' }}>
      <h2>Download Your Certificate</h2>
      <input
        type="text"
        placeholder="Enter your name"
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
        style={{
          padding: '10px',
          fontSize: '16px',
          marginBottom: '20px',
          width: '250px',
        }}
      />
      <br />
      <button
        onClick={generateCertificate}
        disabled={!userName.trim()}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          cursor: 'pointer',
          marginTop: '10px',
        }}
      >
        Download Certificate
      </button>
      <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
    </div> */}
    </>
  );
}


